import React from 'react';
import styled from 'styled-components';
import { NavLink, withRouter, useHistory } from 'react-router-dom';
import { Button, Dropdown, Menu } from 'semantic-ui-react';
import { connect } from 'react-redux';

const Navbar = () => {
  return (
    <LinkBlock>
      <Menu horizontal secondary>
        <Dropdown item text="Питание" style={{ background: '#17ade3' }}>
          <Dropdown.Menu>
            <Dropdown.Item>
              <StyledLink to="/youslim2.0/dishList"> Список блюд</StyledLink>
            </Dropdown.Item>
            <Dropdown.Item>
              <StyledLink to="/youslim2.0/productsList"> Список продуктов</StyledLink>
            </Dropdown.Item>
            <Dropdown.Item>
              <StyledLink to="/youslim2.0/dish/create"> Создать блюдо</StyledLink>
            </Dropdown.Item>
            <Dropdown.Item>
              <StyledLink to="/youslim2.0/product/create"> Создать продукт</StyledLink>
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        <Dropdown item text="Тренировки" style={{ background: '#17ade3' }}>
          <Dropdown.Menu>
            <Dropdown.Item>
              <StyledLink to="/youslim2.0/CreateTrainingTemplate/create">
                Шаблоны тренировок
              </StyledLink>
            </Dropdown.Item>
            <Dropdown.Item>
              <StyledLink to="/youslim2.0/CreateTrainingList/create">Список тренировок</StyledLink>
            </Dropdown.Item>
            <Dropdown.Item>
              <StyledLink to="/youslim2.0/CreateTraining/create">Создать тренировку</StyledLink>
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        <Dropdown item text="Клиенты" style={{ background: '#17ade3' }}>
          <Dropdown.Menu>
            <Dropdown.Item>
              <StyledLink to="/youslim2.0/ClientList"> Список клиентов</StyledLink>
            </Dropdown.Item>
            <Dropdown.Item>
              <StyledLink to="/youslim2.0/userPage/view"> Страница клиента</StyledLink>
            </Dropdown.Item>
            <Dropdown.Item>
              <StyledLink to="/youslim2.0/testPage"> test page</StyledLink>
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        <Dropdown item text="Марафоны" style={{ background: '#17ade3' }}>
          <Dropdown.Menu>
            <Dropdown.Item>
              <StyledLink to="/youslim2.0/marathonPage"> Страница марафона</StyledLink>
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </Menu>
    </LinkBlock>
  );
};

const mapDispatchToProps = (dispatch) => ({});

export default withRouter(connect(null, mapDispatchToProps)(Navbar));

export const LinkBlock = styled.div`
  background: #17ade3;
  display: flex;
  justify-content: center;
  margin-top: -50px;
`;

const activeClassName = 'active';
const StyledLink = styled(NavLink).attrs({
  activeClassName: activeClassName,
})`
  display: block;
  height: 100%;
  padding: 10px;
  margin: -10px;
  color: black;
  line-height: 50px;
  text-decoration: none;
  transition: all 0.3s;
  &:hover {
    // background: #157aac;
    color: #17ade3;
  }
  @media (max-width: 345px) {
    font-size: 14px;
  }
  &.${activeClassName} {
    color: #155aac;
  }
`;



// WEBPACK FOOTER //
// ./src/Components/YouSlim2.0/Navigation/Navbar.jsx